export default {
  install(Vue) {
    Vue.filter('httpToHttps', (str) => {
      let http = new RegExp('^http://', 'g');
      if (http.test(str)) {
        return str.replace('http:', '');
        // return str.replace(http, 'https://');
      }
      return str;
    });
  }
}



// WEBPACK FOOTER //
// ./src/filter/httpToHttps.js